export const INFRACTION_TABLE_COLUMNS = [
	{
		id: "deadline",
		label: "Prazo para Indicação e Pagamento",
		minWidth: 270,
	},
	{ id: "plate", label: "Veículo", minWidth: 89 },
	{ id: "driverName", label: "Condutor", minWidth: 153 },
	{ id: "status", label: "Status", minWidth: 164 },
	{ id: "description", label: "Infração", minWidth: 190 },
	{ id: "autoNumber", label: "Número Auto", minWidth: 90 },
	{ id: "actions", label: "Ações", minWidth: 79 },
] as const;

export const INFRACTION_DESCRIPTION_MAX_LENGTH = 200;

export const INFRACTION_LIST_PAGE_SIZE = 10;

/** Limite alinhado às buscas multi-campo do produto (placa, condutor, AIT). */
export const INFRACTION_LIST_SEARCH_MAX_LENGTH = 80;
